export default __webpack_public_path__ + "static/7_36-646389ca5f5829742d0ea188fb1b5b7c.png";